// extracted by mini-css-extract-plugin
export default {"Plan":"EledoPricingPlan_Plan__34L42","PlanTitle":"EledoPricingPlan_PlanTitle__4Lzhp","PlanLine":"EledoPricingPlan_PlanLine__PleRl"};